import {
  attributionToAnalyticsProperties,
  type IAttribution,
  MARKETING_EVENTS,
} from '@repo/analytics';
import { gtmDataLayerAdapter } from '../gtm-data-layer-adapter';
import { trackEvent } from '../track-event';

const APPLIED_SESSION_KEY = 'cm_attribution_applied';

function buildSignature(attribution: IAttribution): string {
  return [
    attribution.source,
    attribution.medium,
    attribution.campaign,
    attribution.content,
    attribution.referrerUserId,
  ].join('|');
}

export function applyAttributionToAnalytics(attribution: IAttribution): void {
  if (typeof window === 'undefined') {
    return;
  }
  const signature = buildSignature(attribution);
  try {
    if (window.sessionStorage.getItem(APPLIED_SESSION_KEY) === signature) {
      return;
    }
  } catch {}
  const properties = attributionToAnalyticsProperties(attribution);
  for (const [key, value] of Object.entries(properties)) {
    gtmDataLayerAdapter.setUserProperty(key, String(value));
  }
  trackEvent(MARKETING_EVENTS.campaignAttributed, {
    ...properties,
    ...(attribution.referrerUserId ? { ref: attribution.referrerUserId } : {}),
  });
  try {
    window.sessionStorage.setItem(APPLIED_SESSION_KEY, signature);
  } catch {}
}
